import React from 'react';
import { useIntl } from 'react-intl';

import { SMSProviders } from '../../../api';
import { SMS_LINKS } from '../../../constants';
import { FieldInput } from '../../ui';
import {
  DescriptionLink,
  FieldWrapper,
  ProviderSubtitle,
  ProviderTitle,
  SmsProviderFieldsCard,
  SmsProviderHeader
} from '../style';
import { SMSProviderStatus } from './SMSProviderStatus';
import { ProviderFieldProps } from './types';
import { maxFieldLength } from './validator';

export const AlibabaCloudFields = ({ errors, providerData }: ProviderFieldProps): JSX.Element => {
  const intl = useIntl();
  const { ALIBABA_CLOUD_SMS_API } = SMS_LINKS;

  const getError = (field: string): string => {
    if (errors[SMSProviders.alibaba][field]) {
      return intl.formatMessage(
        { id: errors[SMSProviders.alibaba][field] as string },
        { number: maxFieldLength }
      );
    }

    return '';
  };

  return (
    <SmsProviderFieldsCard data-test-id="sms-provider-fields-card-alibaba">
      <SmsProviderHeader>
        <ProviderTitle>
          {intl.formatMessage({ id: 'custom-providers.settings.sms.provider.alibaba.label' })}
        </ProviderTitle>
        <SMSProviderStatus providerData={providerData} />
      </SmsProviderHeader>
      <ProviderSubtitle>
        {intl.formatMessage(
          { id: 'custom-providers.settings.sms.provider.alibaba.description' },
          {
            a: (chunk: string) => (
              <DescriptionLink href={ALIBABA_CLOUD_SMS_API} target="_blank">
                {chunk}
              </DescriptionLink>
            )
          }
        )}
      </ProviderSubtitle>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.alibaba.app-id.label'
          })}
          errorMessage={getError('app_id')}
          name={`fields.${SMSProviders.alibaba}.app_id`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.alibaba.app-secret.label'
          })}
          errorMessage={getError('app_secret')}
          name={`fields.${SMSProviders.alibaba}.app_secret`}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.sms.provider.alibaba.sender-id.label'
          })}
          errorMessage={getError('sender_id')}
          name={`fields.${SMSProviders.alibaba}.sender_id`}
        />
      </FieldWrapper>
    </SmsProviderFieldsCard>
  );
};
